module.exports = __webpack_public_path__ + "images/emoji/couple.b62cb90e31fe33eeae67.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/couple.png
// module id = QZfw
// module chunks = 2